import { Component, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { CommunicationService } from '../../common/services/Communication.service';
import { NavigationClick } from '../../methods/methods';
import { dataModel, Industries, User } from '../../models/data.model';
import { AuthenticationService } from '../../common/services/authentication.service';

export let browserRefresh = false;

@Component({
  selector: '<app-home>',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({
        opacity: 0
      })),
      transition('void <=> *', animate(2000)),
    ]),
  ],
})

export class HomeComponent implements OnInit  {
  data: dataModel;
  isLogin = false;
  currentUser: User;
  onlineIndustries: Industries[]=[];
  offlineIndustries: Industries[] = [];
  
  constructor(
    public onClick: NavigationClick,
    private authenticationServices: AuthenticationService,
    communicationService: CommunicationService) {
    this.data = communicationService.data;
  }

  ngOnInit() {
    this.authenticationServices.currentUser.subscribe(user => {
        this.currentUser = user;
    });
    this.onlineIndustries=this.data.industries.filter(m => m.routers.includes(`online`));
    this.offlineIndustries = this.data.industries.filter(m => !m.routers.includes(`online`));
    
    //console.log(this.data.industries.titles);
  }

  btn(id: string) {
    this.currentUser === null ? this.isLogin = false : this.isLogin = true;
    this.onClick._theNavigateButtons(id, this.isLogin);
  }
}